import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { AuthSessionService } from '@core/auth/auth-session.service';
import { ClientDiagnosticsService } from '@core/diagnostics/client-diagnostics.service';

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const authSession = inject(AuthSessionService);
  const diagnostics = inject(ClientDiagnosticsService);

  return next(req.clone({ withCredentials: true })).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        const isAuthCheck = req.url.includes('/api/auth/') || req.url.endsWith('/api/me');
        if (error.status === 401 && !isAuthCheck) {
          authSession.notifySessionExpired();
        }
        if (!(error.status === 401 && isAuthCheck)) {
          diagnostics.httpFailure(error.status, req.url, error.headers?.get('X-Request-Id') ?? null, req.method);
        }
      }
      return throwError(() => error);
    })
  );
};
